import React from 'react';
import Feature from './OverviewFeature';
import OverviewBatteryFeatures from './OverviewBatteryFeature';
import Searches from './Search';
import RightBarLink from "./ClientRightLink"
import ClientRightTem from "./ClientRightTem"
import ClientGraph from "./ClientGraph"
import ClientAddBank from './ClientAddBank';
import { useState, useEffect, useContext } from "react";
import { MyContext } from "../../context";


function ClientOverview(){

  const {RightLinkSelection, updateRightLinkSelection, updateLinkSelection, updateInstallationLinkSelection} = useContext(MyContext);

  
  const [BankInfo, setBankInfo] = useState({
    id1: {
      name: "Central Office Pack",
      id: "2352kjjfa39919485hf248923g892h3",
      type: "Z-Range",
      location: "Randburg",
      date: "14 June 2013",
    }
  });

  const [PacksInfo, setPacksInfo] = useState({
    id1: {
      name: "Pack 1",
      id: "2352kjjfa39919485hf248234542345",
    },
    id2: {
      name: "Pack 2",
      id: "2352kj98afgdfadf85hfa11346445g2",
    }
  });


  const [TempInfo, setTempInfo] = useState({
    Bank: {
      temp: 3.7,
      min: 3.1,
      max: 20.4
    }, Pack: {
      temp: 3.6,
      min: 3.1,
      max: 20.4
    },

  });


  /*
  const [selectedId, setSelectedId] = useState(null);

  const handleItemClick = (id) => {
    setSelectedId(id);
    console.log(id)
  };*/

  const bankInfoArray = Object.entries(BankInfo).map(([id, item]) => ({ id, ...item }));
  const PacksInfoArray = Object.entries(PacksInfo).map(([id, item]) => ({ id, ...item }));

  let RightLinkSelect = () => {
    switch (RightLinkSelection) {
      case "Bank":
        return (
          <>
              {
              
              bankInfoArray.map((item) => (

              <div key={item.id}>
                <ClientGraph name={item.name} />
                <div style={{marginBottom:"30px"}}></div>
              </div>

                ))
                
                }
          </>
        );
        break;

      case "Pack":
        return (
          <>
              {PacksInfoArray.map((item) => (

              <div key={item.id}>
                <ClientGraph name={item.name} />
                <div style={{marginBottom:"30px"}}></div>
              </div>

                ))}
          </>
        );
        break;

      case "Battery":
        return (
          <>
            Battery
          </>
        );
        break;

        
      case "Cell":
        return (
          <>
            Cells
          </>
        );
        break;

    }
  };

  let RightLinkTemp = () => {
    switch (RightLinkSelection) {
      case "Bank":
        return (
          <>
              {
              <ClientRightTem temp={TempInfo.Bank.temp} max={TempInfo.Bank.max} min={TempInfo.Bank.min}/>
                }
          </>
        );
        break;

      case "Pack":
        return (
          <>
              {
             <ClientRightTem temp={TempInfo.Pack.temp} max={TempInfo.Pack.max} min={TempInfo.Pack.min}/>
                }
          </>
        );
        break;

      case "Battery":
        return (
          <>
            Battery
          </>
        );
        break;

        
      case "Cell":
        return (
          <>
            Cells
          </>
        );
        break;
    }
  };

  const update = () =>{
    
    updateInstallationLinkSelection("Bank")
    updateLinkSelection("Clients")
  }



    return (
       
        <>
          <div className='OverviewContainer'  style={{paddingLeft: "240px", paddingRight: "80px"}}>
            <p className='dashboard_title'>Overview</p>

            <Searches />
          {/*  <ClientOverviewCode />*/} 
          
          <div class="row">
            <div class="col-sm-8">

            {RightLinkSelect()}
      
            </div>
            <div class="col-sm-4">



              <RightBarLink name={BankInfo.id1.name} id={BankInfo.id1.id} type={BankInfo.id1.type} date={BankInfo.id1.date} />
              {RightLinkTemp()}


              <div>
                <span className='BIcon2' onClick={() => update()}><span class="material-symbols-rounded size" style={{paddingTop:"4px", marginRight:"5px"}}>add_box</span> <span style={{paddingTop:"5px"}}>Add Bank Voltage</span></span>
              </div>

            </div>
          </div>


          </div>
        </>
    )
}

export default ClientOverview;